import React from 'react';
import { cn } from '../../../utils/cn';
import { CHIP_KIND_CLASSES, LABEL_DEF, LABEL_MAP, OUTREACH } from '../constants';
import { InvoiceLabel, OutreachState } from '../types';

/**
 * Label chips + outreach-state chip. The `title` attribute carries the plain-language
 * definition (same tooltips the HTML report showed on hover).
 */
/**
 * When auditCorrected is set, drop the structured labels the forensic audit overrode
 * (leak / hard-proof) so the UI doesn't assert a claim the audit rejected.
 */
const AUDIT_SUPPRESSED: InvoiceLabel[] = ['customer_claims_paid_zoho_unpaid', 'has_hard_proof'];

export const LabelChips: React.FC<{ labels: InvoiceLabel[]; auditCorrected?: boolean }> = ({
	labels,
	auditCorrected,
}) => (
	<span className='inline-flex flex-wrap gap-1'>
		{(auditCorrected ? labels.filter(l => !AUDIT_SUPPRESSED.includes(l)) : labels).map(l => {
			const entry = LABEL_MAP[l];
			if (!entry) return null;
			const [text, kind] = entry;
			return (
				<span
					key={l}
					title={LABEL_DEF[l] || ''}
					className={cn(
						'inline-block rounded border px-1.5 py-0.5 text-[10px] font-semibold leading-none',
						CHIP_KIND_CLASSES[kind]
					)}
				>
					{text}
				</span>
			);
		})}
	</span>
);

export const OutreachChip: React.FC<{ state?: OutreachState }> = ({ state }) => {
	if (!state) return null;
	const o = OUTREACH[state];
	if (!o) return null;
	const [text, kind, tip] = o;
	return (
		<span
			title={tip}
			className={cn(
				'inline-block rounded border px-1.5 py-0.5 text-[10px] font-semibold leading-none',
				CHIP_KIND_CLASSES[kind]
			)}
		>
			{text}
		</span>
	);
};
